<template>
  <div>
    <div v-if="f_field.headline" class="mt-1 pt-0 mb-2">
      <v-flex style="background-color: #222; color: #eee; line-height: 28px" class="pl-3 xs12">
        <h3 class="xs12 flex" style="font-size: 16px; text-weigth: 100; height: 28px">
          <span>{{ f_field.title }}</span>
          <v-menu offset-y class="right mb-0" v-if="!f_field.no_dynamic">
            <v-btn slot="activator" icon small dark class="mt-0 mb-0 pt-0">
              <v-icon class="mt-0 pt-0" dark>add</v-icon>
            </v-btn>
            <v-list>
              <div v-for="item in dynamic_field_list" :key="item.name">
                <v-list-tile @click="add_field(item.name)">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-divider inset></v-divider>
                </v-list-tile>
                <v-divider v-if="item.separator" color="black" class="mx-3"></v-divider>
              </div>
            </v-list>
          </v-menu>
        </h3>
      </v-flex>
    </div>

    <div v-else-if="f_field.subheadline" class="mt-2 mb-1">
      <v-flex style="background-color: #ccc; color: 222; line-height: 24px" class="px-3 pb-0 xs12">
        <h3 class="xs12 flex font-weight-normal subheading" style="text-size: 10px !important; text-weigth: 100">
          {{ f_field.title }}
        </h3>
      </v-flex>
    </div>

    <div v-if="f_field.component &&
      ([
        'deaccession_date',
        'comment_on_deaccession',
        'new_ownership',
        'deaccession_price_offer',
        'deaccession_price_paid',
        'invoice_deaccession_papers',
      ].includes(f_field.name)
        ? f_artwork.deaccessioned == 1
        : true)
      " class="mt-2 mb-2 mx-0">
      <component :is="f_field.component" :uploadCategory="f_field.category" :artwork="f_artwork" @getArtwork="getArtwork"
        :name="f_field.name" :field="f_field" :film="film"></component>
    </div>

    <div v-else>
      <!-- && show_if_parent_true -->
      <v-flex v-if="field_type == 'text-short'" px-3 my-0 py-0>
        <v-flex my-0 py-0>
          <label class="labelClass">{{ label }}</label>
          <!-- v-model="f_field.model_string" -->
          <!-- :value="f_field.value_string" -->
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <!-- v-model="current_value" -->
          <v-text-field :error="f_field.obligatory && current_value == ''" browser-autocomplete="off"
            :readonly="!isEditing" :name="f_field.name" :ref="f_field.name"
            :value="f_artwork[f_field.name] ? f_artwork[f_field.name] : ''" :hint="hint" hide-details
            :suffix="f_field.suffix" @input.native="$emit('input', $event.target.value)"
            @keyup="check_an($event.target.value)" @keyup.enter="saveOrEdit" :mask="f_field.mask">
            <!-- @click:append-outer="saveOrEdit" -->
            <!-- :append-outer-icon="isEditing ? 'save' : 'edit'" -->
            <template v-slot:append class="my-0 py-0" style="height: 10px !important">
              <v-btn v-if="isEditing && !an_exists" @click="saveOrEdit" flat small icon color="green" class="mb-0 py-0"
                style="width: 10px !important; height: 10px !important">
                <v-icon class="ma-0 pa-0" small style="width: 10px !important; height: 10px !important">save</v-icon>
              </v-btn>
              <v-btn v-if="isEditing" @click="cancel" flat small icon color="red" class="mb-0 py-0"
                style="width: 10px !important; height: 10px !important">
                <v-icon class="my-0 py-0" small style="height: 10px !important">cancel</v-icon>
              </v-btn>
              <v-btn v-else @click="saveOrEdit" flat small icon color="grey darken-2" class="mb-0 py-0"
                style="width: 10px !important; height: 10px !important">
                <v-icon small>edit</v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <label class="labelClass">{{ f_field.title }}<span v-if="f_field.obligatory"> *</span></label>

          <v-tooltip right v-if="f_field.hint">
            <template #activator="data">
              <v-icon small class="mr-3" v-on="data.on">error_outline</v-icon>
            </template>
            <div v-html="f_field.hint"></div>
          </v-tooltip>

          <div v-if="an_exists" class="red--text">
            This accession number already exists!
          </div>
          <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">
            Value already exists! Cannot save!
          </div>
          <!-- <v-btn v-if="f_field.dynamic" class="ml-3">
            <v-icon>remove</v-icon>
          </v-btn>-->
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'text-auto'" px-3 my-0 py-0>
        <v-flex my-0 py-0 v-if="f_artwork[f_field.name] != '' && f_artwork[f_field.name]">
          <label class="labelClass">{{ f_field.title }}: </label>
          <span>{{ f_artwork[f_field.name] }}</span>
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'currency'" px-3 d-flex>
        <v-flex xs6>
          <!-- {{formatMoney(f_artwork[f_field.name] ? f_artwork[f_field.name] : '')}} -->
          <!-- <label>{{ label }}</label> -->
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <v-flex v-if="!isEditing" xs12>
            <v-flex class="subheading border mt-3 pb-1 mr-3 xs12" style="padding-top: 3px; margin-bottom: 2px">
              <span>{{
                formatMoney(
                  f_artwork[f_field.name] ? f_artwork[f_field.name] : ''
                )
              }}</span>
              <!-- <span class="label body-2">{{ f_field.title }}</span> -->
              <span v-if="!f_field.disabled">
                <v-btn flat @click="saveOrEdit" small icon class="right mr-0 mb-3 mt-0 pt-0">
                  <v-icon small v-if="isEditing" color="green darken-1">save</v-icon>
                  <v-icon small v-if="!isEditing" color="grey darken-1">edit</v-icon>
                </v-btn>
              </span>
            </v-flex>
            <label class="labelClass">{{ f_field.title }}</label>
          </v-flex>

          <v-flex v-else xs12 pr-3>
            <v-text-field :mask="f_field.mask" :readonly="!isEditing || f_field.disabled" :name="f_field.name" :ref="f_field.name"
              :value="f_artwork[f_field.name] ? f_artwork[f_field.name] : ''" :hint="`${f_field.title}`" :loading="saving"
              :suffix="f_field.suffix" @input.native="$emit('input', $event.target.value)"
              @keyup="update_value($event.target.value)" :append-outer-icon="isEditing ? 'save' : 'edit'"
              @click:append-outer="saveOrEdit"></v-text-field>
            <!-- persistent-hint -->
            <!-- <v-btn
              v-if="isEditing"
              flat
              @click="cancel"
              small
              icon
              class="right mr-0"
            >
              <v-icon color="red darken-1">cancel</v-icon>
            </v-btn> -->
          </v-flex>
        </v-flex>

        <v-flex xs6>
          <!-- :append-outer-icon="isEditing ? 'save' : 'edit'"  -->
          <!-- @click:append-outer="saveOrEdit" class="ml-0" -->
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <v-select :readonly="f_field.disabled" hide-details :name="f_field.name + '_currency'" :items="constants.CURRENCIES" :ref="f_field.name + '_currency'" :value="f_artwork[`${f_field.name}_currency`]"
            @change="saveCurrency($event)"></v-select>
          <!-- persistent-hint -->
          <!-- hint="Currency" -->
          <label class="labelClass">Currency</label>
          <div v-if="an_exists">This accession number already exists!</div>
          <!-- <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">Value already exists! Cannot save!</div>-->
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'currency_only'" px-3 d-flex>
        <!-- <v-flex xs12>
          <v-flex v-if="!isEditing">
            <v-flex class="subheading border mt-3 pb-1 mr-3 mb-1" >
              <v-btn
                flat
                @click="saveOrEdit"
                small
                icon
                class="right mr-0 mb-3 mt-0 pt-0"
              >
                <v-icon small v-if="isEditing" color="green darken-1">save</v-icon>
                <v-icon small v-if="!isEditing" color="grey darken-1">edit</v-icon>
              </v-btn>
            </v-flex>
            <label class="ml-1 pt-2" style="color:#999;">{{ f_field.title }}</label>
          </v-flex>
        </v-flex> -->

        <v-flex xs12>
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <!-- @click:append-outer="saveOrEdit" class="ml-0"
            :append-outer-icon="isEditing ? 'save' : 'edit'" 
            :readonly="!isEditing" -->
          <v-select :name="f_field.name + '_currency'" :items="constants.CURRENCIES" :ref="f_field.name" :value="f_artwork[f_field.name]" persistent-hint @change="saveCurrencyOnly($event)"
            hint="Currency"></v-select>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'text-long'" class="mb-0 mt-4 py-0 px-3">
        <!-- :background-color="
            f_field.vernon &&
            !f_artwork['gemini_check'] &&
            [12, 15, 16].includes(f_artwork['ownership'])
              ? '#1d98a3'
              : ''
          " -->
        <v-flex v-if="!isEditing">
          <v-flex :class="{
              'subheading border pb-1': true,
              'mt-4': f_artwork[f_field.name] == null,
            }">
            <span v-html="f_artwork[f_field.name] ? nl2br(f_artwork[f_field.name]) : ''
              "></span>
          </v-flex>
          <!-- <span class="label body-2">{{ f_field.title }}</span> -->
        </v-flex>
        <v-flex v-else>
          <v-textarea class="my-0" auto-grow autofocus :readonly="!isEditing" :name="f_field.name" :ref="f_field.name"
            rows="1" hide-details :value="f_artwork[f_field.name]"
            :hint="`${f_field.title} - ${f_field.hint ? f_field.hint : ''}`" persistent-hint
            @input.native="$emit('input', $event.target.value)" @keyup="update_value($event.target.value)">
          </v-textarea>
          <!-- append-outer-icon="save" -->
          <!-- @click:append-outer="saveOrEdit" -->
        </v-flex>

        <label class="labelClass">{{ f_field.title }}</label>

        <v-tooltip right v-if="f_field.hint">
          <template #activator="data">
            <v-icon small class="mr-3" v-on="data.on">error_outline</v-icon>
          </template>
          <div v-html="f_field.hint"></div>
        </v-tooltip>

        <v-btn v-if="isEditing" flat @click="cancel" small icon class="right mr-0">
          <v-icon small color="red darken-1">cancel</v-icon>
        </v-btn>
        <v-btn flat @click="saveOrEdit" small icon class="right mr-0">
          <v-icon v-if="isEditing" color="green darken-1" small>save</v-icon>
          <v-icon v-if="!isEditing" color="grey darken-1" small>edit</v-icon>
        </v-btn>
        <v-btn color="primary" flat @click="copy2c(f_artwork[f_field.name])" small icon v-if="f_artwork[f_field.name]"
          class="right mr-0">
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
        <div v-if="an_exists">This accession number already exists!</div>
        <div v-if="saved" class="ml-3">Value was saved!</div>
        <div v-if="cannotSave" class="ml-3">
          Value already exists! Cannot save!
        </div>
        <!-- :label="f_field.title" -->
      </v-flex>

      <v-flex xs12 md12 v-else-if="this.field_type == 'date'" :class="`${f_field.class} mt-3 py-0 px-3`">
        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="32" :nudge-top="18" lazy hide-details
          transition="scale-transition" offset-y full-width min-width="290px">
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <!-- :label="f_field.title" -->
          <v-text-field slot="activator" v-model="select_value" prepend-inner-icon="event" readonly
            hide-details></v-text-field>
          <v-date-picker v-model="select_value" @input="menu2 = false" color="black" hide-details
            @change="update_value(select_value)"></v-date-picker>
        </v-menu>
        <label class="labelClass">{{ f_field.title }}</label>
        <!-- <span class="ml-4 pl-2" v-if="f_field['vernon']"
          >Vernon Value: {{ f_artwork[f_field["name"]] }}<br /></span
        > -->
        <!-- <span class="ml-4 pl-2" v-if="f_field['vernon'] && f_field['name'] ==  'market_value_date'"
          >Vernon Date: {{ f_artwork["market_value_date"] }}<br /></span
        > -->
        <!-- <span class="ml-4 pl-2" v-if="f_field['vernon_check']">CMS Value: {{ f_artwork[f_field['name']] }}</span> -->
      </v-flex>

      <v-flex xs12 v-else-if="this.field_type == 'date_separated'" :class="`${f_field.class} mt-3 py-0 mx-3`">
        <v-flex row d-flex wrap xs12 mb-0 pb-0>
          <v-flex xs4 mt-0 pr-3>
            <v-text-field v-model="separated_date.year" label="Year" placeholder="XXXX" mask="####" :readonly="!isEditing"
              type="number" :maxlength="4" hide-details></v-text-field>
          </v-flex>
          <v-flex xs4 mt-0 pr-3>
            <v-text-field v-model="separated_date.month" hide-details label="Month" :readonly="!isEditing" mask="##"
              placeholder="XX" type="number"></v-text-field>
          </v-flex>
          <v-flex xs4 mt-0>
            <v-text-field v-model="separated_date.day" label="Day" mask="##" hide-details placeholder="XX" type="number"
              :readonly="!isEditing"></v-text-field>
          </v-flex>
        </v-flex>

        <!-- <v-text-field
            slot="activator"
            v-model="select_value"
            prepend-inner-icon="event"
            readonly hide-details
          ></v-text-field>
          <v-date-picker
            v-model="select_value"
            @input="menu2 = false"
            color="black" hide-details
            @change="update_value(select_value)"
          ></v-date-picker> -->
        <v-flex xs12>
          <label class="labelClass">{{ f_field.title }} ({{ f_artwork[f_field.name] }})</label>
          <v-btn @click="saveOrEdit" flat small icon color="grey darken-2" class="mb-0 py-0 right"
            style="width: 10px !important; height: 10px !important">
            <v-icon v-if="isEditing" small>save</v-icon>
            <v-icon v-else small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'bool'" px-3 mt-3 d-flex>
        <!-- :background-color="
            f_field.vernon &&
            !f_artwork['gemini_check'] &&
            [12, 15, 16].includes(f_artwork['ownership'])
              ? '#1d98a3'
              : ''
          " -->
        <span class="black--text caption">{{ f_field.title }}</span>
        <v-switch v-model="switch_value" @change="update_value(switch_value)" color="black">
          <template v-slot:label class="black--text">
            <!-- <span class="black--text caption">{{ f_field.title }}</span> -->
            <v-progress-circular indeterminate v-if="progress" value="0" size="14" width="2" background-color="white"
              class="ml-2" color="black"></v-progress-circular>
          </template>
        </v-switch>
        <!-- `${f_artwork[f_field.name]}`" -->
        <!-- v-model="`${f_field.name}`"  -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'radio'" px-3>
        <!-- :background-color="
            f_field.vernon &&
            !f_artwork['gemini_check'] &&
            [12, 15, 16].includes(f_artwork['ownership'])
              ? '#1d98a3'
              : ''
          " -->
        <v-radio-group :label="`${f_field.title}`" :column="f_field.column ? f_field.column : false" :value="value_radio"
          :refs="f_field.name">
          <v-radio v-for="s in f_field.selection" :label="s.name ? s.name : s" :value="s.value ? s.value : s"
            :key="s.id ? s.id : s" class="ml-3" color="black"></v-radio>
        </v-radio-group>

        <v-flex class="xs12 elevation-3 py-3 px-3" v-if="f_field.name == 'sound' && this.value_new == '1'">
          <v-flex c>
            <v-text-field v-model="film.audio_codec" label="Audio Codec" hint="MP3, AAC, AC3 etc."></v-text-field>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-select :items="['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz']" label="Audio Resolution"
              class="ml-0"></v-select>
            <!-- <v-radio-group v-model="film.audio_resolution" label="Audio Resolution" row> -->
            <!-- <v-radio v-for="s in ['32 kHz','44,1 kHz','48 kHz','96 kHz','192 kHz']" :label="s" :value="s" :key="s" class="ml-3"></v-radio> -->
            <!-- </v-radio-group> -->
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-radio-group v-model="film.audio_bit" label="Audio Bit" column>
              <v-radio v-for="s in ['16 Bit', '20 Bit', '24 Bit']" :label="s" :value="s" :key="s" class="ml-3"
                color="black"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <!-- v-model="artwork.fvs_channel_id" -->
            <v-select :ref="fvs_channel_id" :items="constants.CHANNELS" item-value="id" item-text="name" label="Channels"
              class="ml-0"></v-select>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-select :items="[
                'light optical tone',
                'magnetic',
                'digital',
                'unknown',
                'other',
              ]" label="Audio Specs" class="ml-0"></v-select>
            <!-- <v-radio-group v-model="film.audio_specs" label="Audio Specs" row>
              <v-radio v-for="s in ['light optical tone','magnetic','digital','unknown','other']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
            </v-radio-group>-->
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'checkbox'" px-3>
        <v-flex>
          <h4 class="sub-headline mt-3 ml-3">{{ f_field.title }}</h4>
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <v-checkbox v-for="s in f_field.selection" hide-details :label="s.name ? s.name : s" :key="s.id ? s.id : s"
            class="left mr-3 ml-3" color="black" :refs="f_field.name">{{ s.name ? s.name : s }}</v-checkbox>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'toggle'" px-3 mb-2>
        <div class="labelClass mt-3 ml-1">{{ f_field.title }}</div>
        <v-flex xs12 sm6 class="py-2">
          <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
            <v-btn :disabled="f_field.name == 'acquisition_method' &&
              artwork.acquired != 'acquired'
              " small flat v-for="s in selection_items" :key="s.id ? s.value : s" class="px-2" :value="s.value">
              <!-- <v-icon small>format_align_left</v-icon> -->
              <span>{{ s.name }}</span>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-divider color="white"></v-divider>
      </v-flex>

      <v-layout v-else-if="f_field.etype === 'select'" px-3 mt-3 mb-3 row wrap>
        <v-flex v-if="f_field.name != 'fvs_channel_id' ||
          (f_field.name == 'fvs_channel_id' &&
            f_artwork['including_film'] == '1') ||
          [7, 9].includes(f_artwork['type_of_work_id'])
          ">
          <!-- :readonly="!isEditing" -->
          <!-- :value="value2" -->
          <!-- v-model="select_value" -->
          <!-- :background-color="
              f_field.vernon &&
              !f_artwork['gemini_check'] &&
              [12, 15, 16].includes(f_artwork['ownership'])
                ? '#1d98a3'
                : ''
            " -->
          <!-- :label="`${f_field.title}`" -->
          <v-select hide-details v-if="!f_field.just_text" @change="checkSubfields($event)" :value="value2"
            :items="selection_items" item-text="name" item-value="id" :name="f_field.name" :ref="f_field.related_field"
            :preppend-icon="f_field.preicon" :readonly="!isEditing">
            <!-- :append-outer-icon="f_field.addNew ? 'add' : ''" -->
            <!-- @click:append-outer="showAddForm" -->
            <template v-slot:append-outer style="height: 26px !important" class="my-0 py-0">
              <v-btn @click="saveOrEdit" flat small icon color="grey darken-2" style="height: 26px !important"
                class="my-0 py-0">
                <v-icon small class="my-0 py-0" v-if="isEditing" style="height: 26px !important">save</v-icon>
                <v-icon small class="my-0 py-0" v-else style="height: 26px !important">edit</v-icon>
              </v-btn>
            </template>
          </v-select>

          <div v-else>
            {{
              f_artwork[f_field.name]
              ? f_artwork[f_field.name].name
              : 'NOT FOUND'
            }}
          </div>
          <label class="labelClass">{{ f_field.title }}</label>
          <!-- <label style="color:#999;">{{ f_field.title }}</label> -->

          <!-- Gemini -->
          <v-flex v-if="f_field.name == 'ownership' &&
            [12, 15, 16].includes(this.select_value)
            " xs12>
            <!-- <v-radio-group
              label="Gemini Master"
              :value="f_artwork['ownership_gemini']"
              id="ownership_gemini"
              row
              @change="saveSubfield('ownership_gemini', $event)"
            >
              <v-radio
                v-for="s in ['Baron Thyssen', 'FTB']"
                :label="s"
                :value="s"
                :key="s"
                class="ml-3"
                color="black"
              ></v-radio>
            </v-radio-group> -->
            <v-btn-toggle v-model="ownership_gemini" @change="saveSubfield('ownership_gemini', $event)">
              <v-btn small flat v-for="s in ['Baron Thyssen', 'FTB']" :key="s" class="px-2" :value="s" :input-value="s">
                <!-- <v-icon small>format_align_left</v-icon> -->
                <span>{{ s }}</span>
              </v-btn>
            </v-btn-toggle>
            <!-- <v-select
              :value="value2"
              :items="['Baron Thyssen', 'FTB']"
              :name="f_field.name"
              :ref="f_field.related_field"
            ></v-select> -->
          </v-flex>

          <!-- Film Type -->
          <v-flex v-if="f_field.name == 'type_of_work_id' && this.select_value == 7">
            <!-- {{f_artwork['including_film_type']}} -->
            <!-- v-model="film.film_type" -->
            <v-radio-group label="Select Film Type" :value="f_artwork['including_film_type']" row
              @change="saveSubfield('including_film_type', $event)">
              <v-radio v-for="s in ['tape', 'film', 'digital_born']" :label="s" :value="s" :key="s" class="ml-3"
                color="black"></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- Includes -->
          <v-flex v-if="this.f_field.name == 'type_of_work_id' &&
            this.artwork.type_of_work_id == 6
            " class="xs12 mx-0 px-0">
            <v-flex class="xs12 mx-0 px-0 mb-3">
              <v-container grid-list-md text-xs-center style="background-color: #ddd">
                <v-layout row wrap>
                  <v-flex class="subheadline mt-0 xs12 body-2">Includes</v-flex>
                  <!-- <v-checkbox v-for="s in ['Objects','Sound','FilmVideoAV','Slide','Computer Program / Software / File','Performance','Light','Other']"
                    v-model="instalation_includes"
                    :key="s"
                    :label="s"
                    :value="s"
                    hide-details xs12 md6 lg4
                  ></v-checkbox>-->
                  <v-flex xs12 md6 lg4 py-0 my-0 v-for="s in this.$store.state.includes" :key="s.field">
                    <v-checkbox @change="saveSubfield(s.field, f_artwork[s.field])" v-model="f_artwork[s.field]"
                      :label="s.title" :false-value="0" :true-value="1" hide-details color="black"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
              <!-- <v-checkbox
                v-model="included_artwork.including_light"
                key="including_light"
                label="including_light"
                :value="f_artwork['including_light']"
                hide-details xs12 md6 lg4
              ></v-checkbox>-->
            </v-flex>

            <v-flex v-if="this.instalation_includes.indexOf('FilmVideoAV') >= 0" class="xs12 mx-3">
              <v-radio-group v-model="film.film_type" label="Select Film Type" row>
                <v-radio v-for="s in ['tape', 'film', 'digital born']" :label="s" :value="s" :key="s" class="ml-3"
                  color="black"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex v-if="this.instalation_includes.indexOf('Other') >= 0" class="xs12 mx-3">
              <v-text-field v-model="film.film_type" class="ml-3" name="including_other" label="Other" row></v-text-field>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table=='artists'" itemToAdd="f_field"></add-artist>
        </v-flex>-->
      </v-layout>

      <v-flex v-else-if="f_field.etype === 'autocomplete'" mt-2 mb-2 px-3>
        <!-- <v-flex xs1> -->
        <!-- {{selection_items}} -->
        <!-- </v-flex> -->
        <!-- :background-color="
            f_field.vernon &&
            !f_artwork['gemini_check'] &&
            [12, 15, 16].includes(f_artwork['ownership'])
              ? '#1d98a3'
              : ''
          " -->
        <!-- :label="`${f_field.title}`" -->
        <v-autocomplete hide-details @change="checkSubfields($event)" :readonly="!isEditing" :value="value2"
          :items="this.selection_items" :item-text="(item) =>
              item.name
                ? item.name
                : item.company
                  ? item.company
                  : item.first_name + ' ' + item.last_name
            " item-value="id" :chips="f_field.chips" clearable :multiple="f_field.multiple">
          <!-- :append-outer-icon="isEditing ? 'save' : 'edit'"
          @click:append-outer="saveOrEdit" -->
          <!-- <template v-slot:append-outer class="my-0 py-0" style="height:10px !important;">
            <v-btn v-if="isEditing" @click="saveOrEdit" flat small icon color="green" class="my-0 py-0" style="height:10px !important;">
              <v-icon  class="my-0 py-0 " small style="height:10px !important;">save</v-icon>
            </v-btn>
            <v-btn v-if="isEditing" @click="isEditing=false" flat small icon color="red" class="my-0 py-0" style="height:10px !important;">
              <v-icon class="my-0 py-0 " small style="height:10px !important;">cancel</v-icon>
            </v-btn>
            <v-btn v-else @click="saveOrEdit" flat small icon color="grey darken-2">
              <v-icon class="my-0 py-0 " small style="height:10px !important;" small>edit</v-icon>
            </v-btn>
          </template> -->

          <template v-slot:append-outer style="height: 26px !important" class="my-0 py-0">
            <v-btn @click="saveOrEdit" flat small icon color="grey darken-2" style="height: 26px !important"
              class="my-0 py-0">
              <v-icon small class="my-0 py-0" v-if="isEditing" style="height: 26px !important">save</v-icon>
              <v-icon small class="my-0 py-0" v-else style="height: 26px !important">edit</v-icon>
            </v-btn>
          </template>

          <!-- :append-outer-icon="f_field.addNew ? 'add' : ''"
          @click:append-outer="showAddForm"-->
          <!-- <v-icon
            @click="addArtistForm = true"
          >plus</v-icon>-->
        </v-autocomplete>
        <label class="labelClass">{{ f_field.title }}</label>
        <!-- <label style="color:#999;">{{ f_field.title }}</label> -->
        <!-- <v-btn slot="activator" @click="addArtistForm = true" color="grey lighten-2" small icon>
          <v-icon small>add</v-icon>
        </v-btn>-->
        <!-- <v-flex v-if="f_field.name=='classification_new_id' && this.artwork.classification_new_id=='film'">
          Show fvs sub-options here
        </v-flex>-->
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table == 'artists'" itemToAdd="f_field"></add-artist>
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-location v-if="f_field.table == 'artwork_locations'" itemToAdd="f_field"></add-location>
      </v-flex>
    </div>
  </div>
</template>

<script>
// import EditFieldHeader from '@/components/artists/EditFieldHeader'
import ViewArtworks from '@/components/artists/ViewArtworks'
import OwnershipHistory from '@/components/artworks/OwnershipHistory'
// import dynamic_fields from '@/data/dynamic_fields'
import fields from '@/data/full_user_fields'
import AddArtist from '@/components/artists/AddArtist'
import AddLocation from '@/components/locations/AddLocation'
import Upload from '@/components/artworks/Upload'
import Location from '@/components/artworks/Location'
import Insurance from '@/components/artworks/Insurance'
import MarketValueHistory from '@/components/artworks/MarketValueHistory'
import Electrical from '@/components/artworks/Electrical'
import NonElectrical from '@/components/artworks/NonElectrical'
import Films from '@/components/artworks/Films'
import Audio from '@/components/artworks/Audio'
import Programme from '@/components/artworks/Programme'
import InformationCarrier from '@/components/artworks/InformationCarrier'
import Light from '@/components/artworks/Light'
import ReadingDevices from '@/components/artworks/ReadingDevices'
import Links from '@/components/artworks/Links'
import Costs from '@/components/artworks/Costs'
import Conservation from '@/components/artworks/Conservation'
import LoanConditions from '@/components/artworks/LoanConditions'
import axios from '@/utils/apiClient'
import constants from '@/data/constants'
// import * as qs from 'querystring'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
// function nl2br (str, isXhtml) {
//   var breakTag =
//     isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>'
//   return (str + '').replace(
//     /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
//     '$1' + breakTag + '$2'
//   )
// }

export default {
  name: 'edit-field',
  data() {
    return {
      current_value: '',
      valueBeforeEdit: '',
      separated_date: {
        day: Number,
        month: Number,
        year: Number,
      },
      constants: constants,
      saving: false,
      ownership_gemini: '',
      f_artwork: {},
      included_artwork: {
        including_objects: false,
        including_sound: false,
        including_film: false,
        including_slide: false,
        including_computer: false,
        including_performance: false,
        including_light: false,
        including_other: false,
      },
      // includes: [
      //   { title: 'Objects', field: 'including_objects' },
      //   { title: 'Sound', field: 'including_sound' },
      //   { title: 'Film / Video / AV', field: 'including_film' },
      //   { title: 'Slide', field: 'including_slide' },
      //   {
      //     title: 'Computer Program / Software / File',
      //     field: 'including_computer'
      //   },
      //   { title: 'Performance', field: 'including_performance' },
      //   { title: 'Light', field: 'including_light' },
      //   { title: 'Other', field: 'including_other' }
      // ],
      timeout: 2500,
      snackbar: false,
      progress: false,
      toggle: 0,
      switch_value: false,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: fields,
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      showSnackbar: false,
      model: {},
      menu2: '',
      date: '',
      // model: "artwork_location"
      // this.f_field.show
    }
  },
  props: [
    'field',
    'artwork',
    'placeholder',
    'label',
    'name',
    'value',
    'selection',
    'title',
    'film',
    'report',
    'fields_parent',
  ],
  watch: {
    artwork: function () {
      this.f_artwork = Object.assign({}, this.artwork)
      this.ownership_gemini = this.f_artwork['ownership_gemini']
      this.select_value = this.f_artwork[this.f_field.name]
      this.switch_value = this.f_artwork[this.f_field.name] === true ||
        this.f_artwork[this.f_field.name] === 1 ||
        this.f_artwork[this.f_field.name] === '1'
    },
  },
  mounted() {
    // this.valueBeforeEdit = Object.assign(
    //   this.valueBeforeEdit,
    //   this.f_artwork[this.f_field.name]
    // )
    this.f_artwork = Object.assign({}, this.artwork)
    this.current_value = this.f_artwork[this.f_field.name]
    this.ownership_gemini = this.f_artwork['ownership_gemini']
    this.select_value = this.f_artwork[this.f_field.name]
    this.switch_value = this.f_artwork[this.f_field.name] === true ||
      this.f_artwork[this.f_field.name] === 1 ||
      this.f_artwork[this.f_field.name] === '1'
    this.field_value = this.f_artwork[this.f_field.name]
      ? this.f_artwork[this.f_field.name]
      : ''
    this.toggle = this.f_artwork[this.f_field.name]
    this.included_artwork.including_objects =
      this.f_artwork['including_objects']
    this.included_artwork.including_sound = this.f_artwork['including_sound']
    this.included_artwork.including_film = this.f_artwork['including_film']
    this.included_artwork.including_slide = this.f_artwork['including_slide']
    this.included_artwork.including_computer =
      this.f_artwork['including_computer']
    this.included_artwork.including_performance =
      this.f_artwork['including_performance']
    this.included_artwork.including_light = this.f_artwork['including_light']
    this.included_artwork.including_other = this.f_artwork['including_other']
    this.separated_date.year = this.f_artwork[this.f_field.name + '_year']
    this.separated_date.month = this.f_artwork[this.f_field.name + '_month']
    this.separated_date.day = this.f_artwork[this.f_field.name + '_day']
  },
  methods: {
    getArtwork() {
      this.$emit('getArtwork')
    },
    nl2br(str, isXhtml) {
      var breakTag =
        isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>'
      return (str + '').replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        '$1' + breakTag + '$2'
      )
    },
    copy2c(t) {
      navigator.clipboard.writeText(t).then(
        function () {
          // console.log('Async: Copying to clipboard was successful!');
        },
        function (err) {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    saveCurrency(event) {
      // console.log('saveCurrency')
      // console.log(event)
      // console.log(this.f_field.name)
      // this.select_value = event;
      this.saveField(event, this.f_field.name + '_currency')
    },
    saveCurrencyOnly(event) {
      // console.log('saveCurrency')
      // console.log(event)
      // console.log(this.f_field.name)
      // this.select_value = event;
      this.saveField(event, this.f_field.name)
    },
    checkSubfields(event) {
      // console.log('checkSubfields')
      // console.log(event)
      this.select_value = event
      this.saveField(this.select_value)
    },
    showAddForm() {
      this.showingAddForm = !this.showingAddForm
    },
    add_field(field) {
      // console.log('sub')
      // console.log(document.getElementById(field.name))
      this.$emit('show', field)
      // var a = document.getElementById(field.name)
      // console.log(this.$el.style.display)
      // this.$el.style.display = 'block'
      // console.log(this.$children)
      // this.$children.find(a => a.name['name'] == field).styles.display = 'block'
      // console.log(this.$children.find(a => a.name['name'] == field).styles.display)
      // a.style.display = 'block'
      // a.style.backgroundColor = "green"
      // console.log(this.$el.style.display)
      // this.$forceUpdate()
    },
    saveOrEdit() {
      console.log('/////// saveOrEdit A /////////')
      // CHANGE EDITING STATUS
      this.isEditing = !this.isEditing

      // IF NOW NOT EDITING ANYMORE, SHOW PROGRESS & SAVE
      if (!this.isEditing) {
        this.progress = true

        // TOGGLE FIELD NEEDS FALSE & TRUE BE SUBMIT RIGHT VALUE
        if (!this.field_type === 'toggle') {
          if (this.isEditing) {
            this.$refs[this.f_field['name']].isFocused = true
          } else {
            this.$refs[this.f_field['name']].isFocused = false
          }
        }

        // CHECKING READINESS FOR SAVE
        // CHECKING ACCESSION NUMBER
        var saveOK = false
        if (this.f_field.name === 'accession_number') {
          this.check_an(this.current_value)
          // this.check_an(this.f_artwork['accession_number'])
          if (this.an_exists === false) {
            saveOK = true
          }
        } else {
          saveOK = true
        }
        console.log('this.current_value')
        console.log(this.current_value)
        console.log(this.field_value)
        // console.log(this.f_artwork['accession_number'])
        // console.log(this.an_exists)
        // console.log(saveOK)

        var valueToSave = this.current_value

        // COMMENTED BECAUSE OTHERWISE EMPTY VALUE WAS NOT SAVED
        // if (!valueToSave || !valueToSave.trim()) {
        //   valueToSave = this.field_value
        // }

        // TOGGLE FIELD NEED PREVIOUSLY CALCULATED TOGGLE VALUE
        if (this.field_type === 'toggle') {
          valueToSave = this.toggle
        }

        // DATE_SEPARATED FIELD REQUIRES TO SAVE EACH FIELD / YEAR, MONTH, DAY SEPARATELY
        if (this.field_type === 'date_separated') {
          // console.log(this.separated_date)
          this.saveField(this.separated_date.year, `${this.f_field.name}_year`)
          this.saveField(
            this.separated_date.month,
            `${this.f_field.name}_month`
          )
          this.saveField(this.separated_date.day, `${this.f_field.name}_day`)
        }

        // FOR OTHER FIELD TYPES
        if (saveOK) {
          this.saveField(valueToSave)
        } else {
          this.cannotSave = true
          setTimeout(() => {
            this.cannotSave = false
          }, 4000)
        }
      }
      console.log('/////// saveOrEdit B /////////')
    },
    cancel() {
      // this.f_artwork[this.f_field.name] = this.select_value
      this.isEditing = false
    },
    saveSubfield(field, value) {
      this.$emit('showSnackbar', 'Saving ' + field + '… ')
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
        axios
          .put(url, {
            field_name: field,
            field_value: value,
            updated_by: this.c_user.id,
          })
          .then((response) => {
            // console.log("axios");
            this.$emit('getArtwork', 'test')
            // console.log("axios2");
            this.$emit('showSnackbar', 'Saved ' + field, 'green')
            this.progress = false
            this.isEditing = false
          })
          .catch((error) => {
            this.$emit('showSnackbar', 'Error Saving  ' + field, 'red')
            // console.log(error)
            this.progress = false
            this.isEditing = false
          })
      }, 1000)
    },
    // saveField (valueToSave) {
    //   this.$emit('showSnackbar', 'Saving… ')
    //   console.log('saveField')
    //   console.log(valueToSave)
    //   setTimeout(() => {
    //     let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
    //     axios.put(url, {
    //       'field_name': this.f_field.name,
    //       'field_value': valueToSave,
    //       'updated_by': this.c_user.id
    //       })
    //       .then((response) => {
    //         // console.log('saveField THEN')
    //         // console.log(this.f_field.name)
    //         this.$emit('showSnackbar', 'Saved ' + this.f_field.name)
    //         this.progress = false
    //         this.isEditing = false
    //         // this.$store.dispatch('addArtwork',response.data)
    //       }).catch((error) => {
    //         // console.log(error)
    //       })
    //       // this.saved = false
    //   }, 1000);
    // },
    saveField(valueToSave, field) {
      console.log('//valueToSave')
      console.log(valueToSave)
      this.saving = true
      this.$emit('showSnackbar', 'Saving ' + this.f_field.name + '… ')
      var f = ''
      if (field) {
        f = field
      } else {
        f = this.f_field.name
      }
      console.log('//saveField')
      console.log(f)
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
        axios
          .put(url, {
            field_name: f,
            field_value: valueToSave,
            updated_by: this.c_user.id,
          })
          .then((response) => {
            this.$emit('showSnackbar', 'Saved ' + this.f_field.name, 'green')
            this.progress = false
            if (
              [
                'accession_number',
                'acquired',
                'acquisition_method',
                'acquisition_source_id',
                'artist_id',
                'credit',
                'fvs_channel_id',
                'fvs_subtitle',
                'gender',
                'production_date_new, century',
                'registrar_id',
                'signature, not_signed',
                'signature_new - signed, not_signed',
                'subtitle',
                'title',
                'series',
                'type_of_work_id',
                'visa_status',
                'ownership',
              ].includes(this.f_field.name)
            ) {
              this.updateTag(f, this.artwork.id, valueToSave)
            }
            this.$emit('getArtwork')
            this.saving = false
            this.isEditing = false
            // this.$store.dispatch('loadArtworks', null);
          })
          .catch((error) => {
            this.$emit(
              'showSnackbar',
              'Error Saving  ' + this.f_field.name + ' - ' + error,
              'red'
            )
            this.progress = false
            this.saving = false
            this.isEditing = false
          })
      }, 1000)
    },
    updateTag(field, artwork_id, value) {
      // console.log('updateTags')
      // var tag = value
      let url = `${this.$globals.apiserver}/tags.json`
      axios
        .post(url, {
          tag: {
            name: value,
            category: field.name,
            created_by: this.c_user.id,
          },
        })
        .then((response) => {
          this.$store.dispatch('loadTags')
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    update_value(value) {
      console.log('update_value')
      this.current_value = value
      this.field_value = value
      if (this.field_type === 'bool') {
        let val = ''
        if (this.switch_value === true) {
          val = 1
        }
        if (this.switch_value === false) {
          val = 0
        }
        this.field_value = val // this.switch_value;
        this.saveField(this.field_value)
      }
      if (this.field_type === 'date') {
        this.field_value = this.switch_value
        this.saveField(value)
      }
    },
    check_an(value) {
      console.log('check_an')
      console.log(this.current_value)
      this.current_value = value
      console.log(this.current_value)
      console.log('check_an')
      // this.field_value = value
      if (
        this.f_field.name === 'accession_number' &&
        this.isEditing === true &&
        value != this.f_artwork[this.f_field.name]
      ) {
        var a = Object.assign([], this.$store.state.artworks)
        var b = a.find((aa) => aa.accession_number == value)
        this.an_exists = b
      } else {
        this.an_exists = false
      }
    },
    location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find((l) => l.id === id).name
      } else {
        return 'Location not found. Probably deleted from CMS.'
      }
    },
  },
  computed: {
    show_if_parent_true() {
      // if (this.f_field.show_on_parent_true) {
      //   return this.artwork[this.parent_conditional_field] == this.f_field.conditional_field_true_value
      // } else {
      return true
      // }
    },
    hint() {
      var out = this.f_field.title
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '')
      return out
    },
    value2() {
      if (this.f_field.related_field) {
        return parseInt(this.f_artwork[this.f_field.related_field], 10)
      } else {
        // if (this.f_field.name !== 'paid_in_country') {
        return this.f_artwork[this.f_field.name]
        // } else {
        //   return this.f_artwork[this.f_field]
      }
    },
    value_radio() {
      return this.f_artwork[this.f_field.name]
    },
    dynamic_field_list() {
      if (this.f_field.headline) {
        var c = []
        var fields2
        if (this.report) {
          fields2 = this.fields_parent
        } else {
          fields2 = this.fields['tabs'][this.$store.state.currentTab]['fields']
        }
        c = fields2.filter(
          (f) => f.dynamic && f.section === this.f_field.section
        )
        c = c.filter(
          (f) =>
            f.work_types_new &&
            f.work_types_new.includes(this.artwork.type_of_work_id)
        )
        return c
      } else {
        return []
      }
    },
    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artwork[this.f_field.name]
    // var ndate = moment(this.f_artwork[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artwork[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype
    },
    selection_items() {
      if (this.f_field.constant_selection) {
        // console.log(this.f_field.constant_selection)
        // console.log(constants)
        return constants[this.f_field.constant_selection]
      } else {
        if (this.f_field.table) {
          if (this.f_field.table === 'contacts') {
            var contacts = Object.assign([], this.$store.state.contacts)
            if (this.f_field.column) {
              return contacts
                .filter(
                  (c) => c[this.f_field.column] === this.f_field.association
                )
                .sort(dynamicSort('name'))
            } else {
              return contacts.sort(dynamicSort('name'))
            }
          }
          if (this.f_field.table === 'languages') {
            var languages = Object.assign([], constants.LANGUAGES)
            if (this.f_field.column) {
              // console.log(contacts);
              return languages
                .filter(
                  (c) => c[this.f_field.column] === this.f_field.association
                )
                .sort(dynamicSort('name'))
            } else {
              return languages.sort(dynamicSort('name'))
            }
          }
          if (this.f_field.table === 'countries') {
            var countries = Object.assign([], constants.COUNTRIES)
            // if (this.f_field.column) {
            //   // console.log(contacts);
            //   return countries
            //     .filter(c => c[this.f_field.column] == this.f_field.association)
            //     .sort(dynamicSort("name"));
            // } else {
            return countries.map((c) => Object.assign({ id: c, name: c }))
            // .sort(dynamicSort("name"));
            // }
          }
          if (this.f_field.table === 'artists') {
            var artists = Object.assign([], this.$store.state.artists)
            if (this.f_field.column) {
              return artists.filter(
                (c) => c[this.f_field.column] === c[this.f_field.association]
              )
            } else {
              return artists.sort(dynamicSort('name'))
            }
          }
          if (this.f_field.table === 'artwork_locations') {
            // console.log(this.f_field.table)
            // console.log('this.f_field.table')
            var artworkLocations = Object.assign(
              [],
              this.$store.getters.enabled_locations
            )
            if (this.f_field.column) {
              return artworkLocations.filter(
                (c) => c[this.f_field.column] === c[this.f_field.association]
              )
            } else {
              return artworkLocations.sort(dynamicSort('name'))
            }
          }
        }
        if (this.f_field.selection && this.f_field.selection.length > 0) {
          return this.f_field.selection
        }
      }
    },
    f_field() {
      var f = this.field
      f.model_string = this.field.model_string
        ? this.field.model_string
        : this.field.name
      f.column = this.field.column ? this.field.column : false
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string']
        ? this[this.field.model_string]
        : this.f_artwork[this.field.name]
      return f
    },
    // f_artwork() {
    //   return this.artwork;
    // }
    // value_calculated () {
    //   let output = ''
    //   switch (this.f_field.table) {
    //     case 'artworks':
    //       if (this.f_field.name)
    //         output = nl2br(this.f_artwork[this.field.name])
    //       else
    //         output = 'no artwork name entered in cms'
    //       break
    //     case 'artwork_locations':
    //       output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
    //       break
    //     case 'contacts':
    //       output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
    //       break
    //     default:
    //       output = nl2br(this.f_artwork[this.f_field.name])
    //     if (output === undefined) {
    //       output = ''
    //     }
    //     if (output === null) {
    //       output = 0
    //     }
    //     if (this.f_field.suffix) {
    //       output += this.f_field.suffix
    //     }
    //       // console.log(this.f_artwork)
    //   }
    //   return output
    // },
    // value_from_array () {
    //   let v = this.value_calculated
    //   return this.f_field.options[v]
    // },
    // value_calculated_empty () {
    //   let output = ''
    //   // let a = this.f_artwork.id
    //   // console.log(this.f_artwork)
    //   switch (this.f_field.table) {
    //     case 'artworks':
    //       if (typeof this.f_artwork !== 'undefined') {
    //         output = this.f_artwork[this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'artwork_locations':
    //       if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
    //         output = this.f_artwork[this.f_field.association][this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'contacts':
    //       if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
    //         output = (this.f_artwork[this.f_field.association][this.f_field.name])
    //       } else {
    //         output = ''
    //       }
    //       break
    //     default:
    //       output = this.f_artwork[this.f_field.name]
    //   }
    //   let o=false
    //   if (output=='' || output==undefined || output==null) {
    //     o = false
    //   } else {
    //     o = true
    //   }
    //   return o
    // }
  },
  components: {
    Conservation,
    OwnershipHistory,
    AddLocation,
    AddArtist,
    Costs,
    ViewArtworks,
    Upload,
    Location,
    Insurance,
    MarketValueHistory,
    Films,
    Audio,
    Light,
    Programme,
    InformationCarrier,
    Electrical,
    ReadingDevices,
    Links,
    NonElectrical,
    LoanConditions,
  },
}
</script>

<style scoped>
.labelClass {
  color: #555;
}

.border {
  border-bottom: solid 1px #777;
}

.label {
  color: #aaa;
}

li {
  list-style: none;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/EditField.vue